var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { useMemo, useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router-dom';

import { useSetRecoilState } from 'recoil';
import * as ixAPI from "../../../api/ix";
import * as templatesAPI from "../../../api/templates";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { Button, ConfirmationModal, Table } from "../../../Components/UI";
import { Translate, t } from "../../../../I18N";
import { notificationAtom } from "../../../atoms";

import { ExtractorModal } from "./components/ExtractorModal";
import { tableColumns } from "./components/TableElements";
import { List } from "./components/List";

const formatExtractors = (
extractors,
templates) =>

extractors.map((extractor) => {
  let propertyType = 'text';
  let propertyLabel = t('System', 'Title', null, false);

  const namedTemplates = extractor.templates.map((extractorTemplate) => {var _templates$find;
    const templateName =
    ((_templates$find = templates.find((template) => template._id === extractorTemplate)) === null || _templates$find === void 0 ? void 0 : _templates$find.name) || extractorTemplate;
    return templateName;
  });

  templates.forEach((template) => {
    const property = template.properties.find(
      (templateProperty) => templateProperty.name === extractor.property
    );

    if (property) {
      propertyType = property.type;
      propertyLabel = t(template._id, property.label, null, false);
    }
  });

  return _objectSpread(_objectSpread({}, extractor), {}, { namedTemplates, propertyType, propertyLabel });
});

const IXDashboard = () => {
  const { extractors, templates } = useLoaderData();



  const revalidator = useRevalidator();
  const [selected, setSelected] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [extractorModal, setExtractorModal] = useState(false);
  const setNotifications = useSetRecoilState(notificationAtom);

  const formmatedExtractors = useMemo(
    () => formatExtractors(extractors, templates),
    [extractors, templates]
  );

  const deleteExtractors = async () => {
    const extractorIds = selected.map((selection) => selection.original._id);

    try {
      await ixAPI.remove(extractorIds);
      revalidator.revalidate();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Extractor/s deleted")
      });
    } catch (error) {var _error$json;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json = error.json) !== null && _error$json !== void 0 && _error$json.prettyMessage ? error.json.prettyMessage : undefined
      });
    }
  };

  const handleSave = async (extractor) => {
    try {
      await ixAPI.save(extractor);
      revalidator.revalidate();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Saved successfully.")
      });
    } catch (error) {var _error$json2;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json2 = error.json) !== null && _error$json2 !== void 0 && _error$json2.prettyMessage ? error.json.prettyMessage : undefined
      });
    }

    setExtractorModal(false);
  };

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-ix",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Metadata extraction dashboard" }), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: formmatedExtractors,
      columns: tableColumns,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Extractors"),
      enableSelection: true,
      onSelection: setSelected,
      initialState: { sorting: [{ id: 'name', desc: false }] } }
    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "flex gap-2" }, void 0,
    selected.length === 1 ? /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: () => setExtractorModal(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Edit Extractor")
    ) :
    undefined,

    selected.length ? /*#__PURE__*/
    _jsx(Button, { type: "button", color: "error", onClick: () => setConfirmModal(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete")
    ) : /*#__PURE__*/

    _jsx(Button, { type: "button", onClick: () => setExtractorModal(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Create Extractor")
    )

    )
    ),

    confirmModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: "Delete extractors",
      warningText: "Do you want to delete the following items?",
      body: /*#__PURE__*/_jsx(List, { items: selected }),
      onAcceptClick: async () => {
        await deleteExtractors();
        setConfirmModal(false);
        setSelected([]);
      },
      onCancelClick: () => setConfirmModal(false),
      dangerStyle: true }
    ), /*#__PURE__*/


    _jsx(ExtractorModal, {
      isOpen: extractorModal,
      onClose: () => setExtractorModal(false),
      onAccept: async (extractor) => handleSave(extractor),
      templates: templates,
      extractor: selected.length ? selected[0].original : undefined }
    )
    ));

};

const dashboardLoader =
(headers) =>
async () => {
  const extractors = await ixAPI.get(headers);
  const templates = await templatesAPI.get(headers);
  return { extractors, templates };
};

export { IXDashboard, dashboardLoader };